import type { Role } from "@avestate/shared";

const RANK: Record<Role, number> = {
  viewer: 1,
  reviewer: 2,
  editor: 3,
  admin: 4,
  owner: 5,
};

export function hasRole(current: Role | null, min: Role): boolean {
  if (!current) return false;
  return RANK[current] >= RANK[min];
}

export function roleLabel(r: Role): string {
  return ({
    owner: "Owner",
    admin: "Admin",
    editor: "Editor",
    reviewer: "Revisore",
    viewer: "Viewer",
  } satisfies Record<Role, string>)[r];
}
